import React from "react";
import { Link } from "@quintype/components";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";

import "./google-ps.m.css";

export const GooglePs = () => {
  return (
    <div styleName="google-ps">
      <Link href="https://google.com/preferences/source?q=gulfnews.com" id="googleps" target="_blank">
        <SvgIconHandler type="google" width="48" height="24" viewBox="0 0 24 24" />
        <div>Add as a preferred source on Google</div>
      </Link>
    </div>
  );
};
